import { ApiPath } from 'common/enums/http/api-path';
import type { ResponseWithPagination } from 'common/types';
import type { FleetAllUpdates } from 'models/fleet-all-updates';
import { http } from 'services/http';

export const getFleetAllUpdatesApi = () =>
  http.get<ResponseWithPagination<FleetAllUpdates>>(ApiPath.FLEET_ALL_UPDATES);
